module.exports = [
  ...require('./itemGroups/smokepowder'),
  require('./list/blackstaff'),
  require('./list/bracer_of_flying_daggers'),
  require('./list/feather_of_diatryma_summoning'),
  require('./list/knave_s_eye_patch'),
  require('./list/paper_bird'),
  require('./list/ring_of_truth_telling'),
]
